var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupUsersGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.2914V19.9257C24 17.7211 22.534 15.8686 20.55 15.3433M16.525 1.34393C18.2108 2.04582 19.4 3.74578 19.4 5.73143C19.4 7.71708 18.2108 9.41704 16.525 10.1189M18.25 22.2914C18.25 20.0869 18.25 18.9846 17.8998 18.1151C17.433 16.9557 16.5375 16.0347 15.4103 15.5544C14.565 15.1943 13.4933 15.1943 11.35 15.1943H7.9C5.75667 15.1943 4.685 15.1943 3.83966 15.5544C2.71253 16.0347 1.81703 16.9557 1.35015 18.1151C1 18.9846 1 20.0869 1 22.2914M14.225 5.73143C14.225 8.34452 12.1655 10.4629 9.625 10.4629C7.08449 10.4629 5.025 8.34452 5.025 5.73143C5.025 3.11833 7.08449 1 9.625 1C12.1655 1 14.225 3.11833 14.225 5.73143Z",
    stroke: "#38CB89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUsersGreen);
export default __webpack_public_path__ + "static/media/group-users-green.59e870f4e0bba0b699a572e96777bdb9.svg";
export { ForwardRef as ReactComponent };